import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import DataGridKeywordExact from "src/components/data-grid/activations/data-grid-keyword-exact";
import { useGetKeywordsQuery } from "src/context/api/activations/api";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";

export default function ActivationsKeywordExact(country: any) {
    const workspace = useCurrentWorkspace();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [localPatches, setLocalPatches] = useState({});

    const { data: keywordsExact, isFetching } = useGetKeywordsQuery(
        {
            client: workspace?.bqTable,
            page: page + 1,
            page_size: pageSize,
            workspace_id: workspace?.id,
            match_type: "EXACT",
            country: country?.country
        }, { skip: !workspace });

    return (
        <Box    >
            {isFetching ? (
                <Skeleton
                    variant="rectangular"
                    height={400}
                    width="100%"
                    animation="wave"
                />
            ) : (
                <DataGridKeywordExact
                    data={keywordsExact?.data ?? []}
                    rowCount={keywordsExact?.total ?? 0}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={setPage}
                    onPageSizeChange={setPageSize}
                    localPatches={localPatches}
                    setLocalPatches={setLocalPatches}
                />
            )}
        </Box>
    );
}